/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Hint_OpenInputs */

const en_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` to open`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " to open" }])
			})
		}
	)
);

const zh_hans1_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` 打开`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " 打开" }])
			})
		}
	)
);

const pt_br2_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para abrir`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " para abrir" }])
			})
		}
	)
);

const es_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` para abrir`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " para abrir" }])
			})
		}
	)
);

const fr_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` pour ouvrir`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " pour ouvrir" }])
			})
		}
	)
);

const de_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` zum Öffnen`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " zum Öffnen" }])
			})
		}
	)
);

const ru_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` чтобы открыть`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " чтобы открыть" }])
			})
		}
	)
);

const it_search_hint_open = /** @type {((inputs: Search_Hint_OpenInputs) => LocalizedString) & { parts: (inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Search_Hint_OpenInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (` per aprire`)
		}),
		{
			parts: /** @type {(inputs: Search_Hint_OpenInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-standalone", name: "enter", options: {}, attributes: {} }, { type: "text", value: " per aprire" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "to open" |
*
* @param {Search_Hint_OpenInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_hint_open = /** @type {((inputs?: Search_Hint_OpenInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Search_Hint_OpenInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Search_Hint_OpenInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { enter: { options: {}; attributes: {}; children: false } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Search_Hint_OpenInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_search_hint_open(inputs)
			if (locale === "pt-BR") return pt_br2_search_hint_open(inputs)
			if (locale === "es") return es_search_hint_open(inputs)
			if (locale === "fr") return fr_search_hint_open(inputs)
			if (locale === "de") return de_search_hint_open(inputs)
			if (locale === "ru") return ru_search_hint_open(inputs)
			if (locale === "it") return it_search_hint_open(inputs)
			return en_search_hint_open(inputs)
		}),
		{
			parts: /** @type {(inputs?: Search_Hint_OpenInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_search_hint_open.parts === "function" ? zh_hans1_search_hint_open.parts(inputs) : [{ type: "text", value: zh_hans1_search_hint_open(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_search_hint_open.parts === "function" ? pt_br2_search_hint_open.parts(inputs) : [{ type: "text", value: pt_br2_search_hint_open(inputs) }]
				if (locale === "es") return typeof es_search_hint_open.parts === "function" ? es_search_hint_open.parts(inputs) : [{ type: "text", value: es_search_hint_open(inputs) }]
				if (locale === "fr") return typeof fr_search_hint_open.parts === "function" ? fr_search_hint_open.parts(inputs) : [{ type: "text", value: fr_search_hint_open(inputs) }]
				if (locale === "de") return typeof de_search_hint_open.parts === "function" ? de_search_hint_open.parts(inputs) : [{ type: "text", value: de_search_hint_open(inputs) }]
				if (locale === "ru") return typeof ru_search_hint_open.parts === "function" ? ru_search_hint_open.parts(inputs) : [{ type: "text", value: ru_search_hint_open(inputs) }]
				if (locale === "it") return typeof it_search_hint_open.parts === "function" ? it_search_hint_open.parts(inputs) : [{ type: "text", value: it_search_hint_open(inputs) }]
				return typeof en_search_hint_open.parts === "function" ? en_search_hint_open.parts(inputs) : [{ type: "text", value: en_search_hint_open(inputs) }]
			})
		}
	)
);